import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { SText } from '@setvi/shared/components';
import { InfoIconV2 } from '@setvi/shared/components/sicons';
import { DismissBtn, WarningContainer } from '../style';
import {
  Warning,
  WarningContent,
  WarningIconBox
} from '../../../pdf-preview-tab/styled';

interface ValidationWarningProps {
  visible: boolean;
  onDismiss: () => void;
}

export const ValidationWarning = ({
  visible,
  onDismiss
}: ValidationWarningProps) => {
  if (!visible) return null;

  return (
    <WarningContainer>
      <Warning
        style={{
          width: '95%'
        }}>
        <WarningContent>
          <WarningIconBox>
            <InfoIconV2
              fill="white"
              style={{
                transform: 'rotate(180deg)'
              }}
            />
          </WarningIconBox>
          <SText
            title="Please make sure all required information is filled in before you continue."
            fontColor="#FA2020"
          />
        </WarningContent>

        <DismissBtn
          onClick={onDismiss}
          variant="text"
          color="default"
          startIcon={
            <CloseRoundedIcon
              style={{
                marginBottom: 3
              }}
            />
          }>
          Dismiss
        </DismissBtn>
      </Warning>
    </WarningContainer>
  );
};
